import { render, staticRenderFns } from "./app-pre-create-modal.vue?vue&type=template&id=2dff9521&scoped=true"
import script from "./app-pre-create-modal.vue?vue&type=script&lang=js"
export * from "./app-pre-create-modal.vue?vue&type=script&lang=js"
import style0 from "./app-pre-create-modal.vue?vue&type=style&index=0&id=2dff9521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff9521",
  null
  
)

export default component.exports